module.exports = __webpack_public_path__ + "static/media/mt-ut-img-7.542da8c4.png";